import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'

import { Box } from '@shared/components/Box'

import styles from './OrSeparator.module.scss'

export const OrSeparator: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box flex align='center' gap='x16' fullWidth>
      <span className={styles.line} />
      <Body2 color='text-med-em'>{t('Or')}</Body2>
      <span className={styles.line} />
    </Box>
  )
}
